import React, { useEffect, useState } from "react";
import { TableCell, TableRow, TextField } from "@mui/material";
import "./DestinationCountryCost.css";
import { useDispatch, useSelector } from "react-redux";
import { updateDDU } from "../Redux/Reducer/DDUReducer";
import { groupedByOrigin } from "../CountryWithNoPortData/GroupedByOrigin";
const rowHeight = 10;
const fontStyle = {
  // fontFamily: "Inter",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  letterSpacing: "-0.387px",
};
const headerColorDDU = {
  height: rowHeight,
};
const innerRowHeight = {
  padding: "2px",
  height: rowHeight,

  color: "#000",
  ...fontStyle,
  borderRadius: "5px",
};
const textFieldStyle = {
  height: rowHeight,
  color: "#62696b",
  input: { textAlign: "center" },
  ...fontStyle,
};
const textFieldInput = {
  style: {
    height: rowHeight + 9,
    padding: "0px",
  },
};
const buttonStyle = {
  color: "#1850FF",
  ...fontStyle,
  textDecoration: "underline",
  fontWeight: 600,
  cursor: "pointer",
};
const DestinationCountryCost = ({
  currencyRate,
  selectedHeader,
  fobData,
  countryNames,
  selectedOriginCity,
  destinationCountryData,
  setDestinationCountryDataUpdatedData,
  from,
  getLatest,
  currency,
}) => {
  const [data, setData] = useState([]);
  const [totals, setTotals] = useState([]);
  const [showRow, setShowRow] = useState(true);
  const dispatch = useDispatch();
  // const CIF = useSelector((state) => state.CIFData.CIF);
  const CIF = useSelector((state) => state.CIFValue.CIFValue);

  const [updatedValue, setUpdatedValue] = useState([]);
  const FOB = useSelector((state) => state.FOBData.FOB);

  const normalizeCountry = (country) => {
    if (!country || typeof country !== "string") return "";
    return country
      .trim()
      .toLowerCase()
      .replace(/^./, (c) => c.toUpperCase());
  };

  function toLowerCaseKeys(obj) {
    try {
      // Validate input: must be non-null plain object
      if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
        return {}; // fallback
      }

      // Convert keys to lowercase
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          if (typeof key !== "string") {
            return [key, value];
          }

          // If value is an object, recursively normalize
          if (
            typeof value === "object" &&
            value !== null &&
            !Array.isArray(value)
          ) {
            return [key.toLowerCase(), toLowerCaseKeys(value)];
          }

          return [key.toLowerCase(), value];
        })
      );
    } catch (error) {
      return {}; // safe fallback
    }
  }

  const calculateTotal = (row, countryValue, countryName) => {
    const getNumber = (value) => {
      const num = parseFloat(value);
      return !isNaN(num) ? num : 0;
    };
    const terminal = getNumber(row.Terminal);
    const customs = getNumber(row.CustomsClearance);
    const logistic = getNumber(row.Logistic);
    const tariff = getNumber(row.TariffValue);
    const otherCharges =
      countryName !== selectedHeader ? getNumber(row.otherChargesValue) : 0;
    const additionalCharges =
      countryName !== selectedHeader ? getNumber(row.additionalCharges) : 0;

    const countryVal = getNumber(countryValue);

    const total =
      terminal +
      customs +
      logistic +
      otherCharges +
      tariff +
      countryVal +
      additionalCharges;

    return parseFloat(total.toFixed(1));
  };

  const updateTotals = (updatedData) => {
    const newTotals = updatedData.map((row) => {
      // const countryName = normalizeCountry(row.Country);
      // const countryValue = CIF?.[0]?.[countryName] ?? 0;
      const lowerCaseCIF = toLowerCaseKeys(CIF[0]);

      const countryName = normalizeCountry(row.Country).toLowerCase();
      const countryValue = lowerCaseCIF[countryName] ?? 0;

      return calculateTotal(row, countryValue, countryName);
    });

    setTotals(newTotals);

    // Second: Generate country-wise totals and update Redux

    const countryTotals = data.reduce((acc, row) => {
      // const countryName = normalizeCountry(row.Country);
      // const countryValue = CIF?.[0]?.[countryName] ?? 0;/
      const lowerCaseCIF = toLowerCaseKeys(CIF[0]);

      // Access value using a lowercased key
      const countryName = normalizeCountry(row.Country).toLowerCase();
      const countryValue = lowerCaseCIF[countryName] ?? 0;

      // countryName !== "Usa"
      //   ? CIF?.[0]?.[countryName] ?? 0
      //   : fobData?.[countryName] ?? 0;

      const total = calculateTotal(row, countryValue, countryName);

      acc[countryName] = total;
      return acc;
    }, {});

    dispatch(updateDDU(countryTotals));
  };

  useEffect(() => {
    const transformedData = countryNames.map((country) => {
      const item = destinationCountryData.find(
        (entry) => entry?.country === country
      );

      const valueOfSum =
        item?.tariff_calculate_on === "CIF"
          ? CIF[0] && CIF[0][country]
          : country && fobData[country];

      const tariffValue =
        from === "bookmark"
          ? (valueOfSum * item?.TariffPercentage) / 100
          : (valueOfSum * item?.tariff) / 100;

      const cifdutyValue =
        item?.value_calculation_format?.toLowerCase() === "percentage"
          ? ((CIF[0]?.[country] ?? 0) * item?.other_charge_value) / 100 +
            tariffValue
          : (CIF[0]?.[country] ?? 0) + item?.other_charge_value + tariffValue;

      const dutyValue =
        item?.value_calculation_format?.toLowerCase() === "percentage"
          ? (tariffValue * item?.other_charge_value) / 100
          : tariffValue + item?.other_charge_value;

      const normalizedChargeMap = {
        duty: dutyValue,
        "import duty": dutyValue,
        cif:
          item?.value_calculation_format?.toLowerCase() === "percentage"
            ? ((CIF[0]?.[country] ?? 0) * item?.other_charge_value) / 100
            : (CIF[0]?.[country] ?? 0) + item?.other_charge_value,
        fob:
          item?.value_calculation_format?.toLowerCase() === "percentage"
            ? ((fobData?.[country] ?? 0) * item?.other_charge_value) / 100
            : (fobData?.[country] ?? 0) + item?.other_charge_value,
        "cif+duty": cifdutyValue,
        "cif + duty": cifdutyValue,
        "cif&duty": cifdutyValue,
      };

      const lookupKey =
        item?.other_chage_calculate_on?.toLowerCase?.().trim() ?? "";

      const OtherChargesFinalValue = normalizedChargeMap[lookupKey] ?? 0;
      const isSameCountry =
        country?.toLowerCase() === selectedHeader?.toLowerCase();

      const originDestinations =
        groupedByOrigin[
          country?.charAt(0)?.toUpperCase() + country?.slice(1)
        ] || [];

      const hasDestination = originDestinations
        .map((dest) => dest?.toLowerCase())
        .includes(selectedHeader?.toLowerCase());

      return {
        Country: country,
        Logistic: item?.logistics_cost ?? 0,
        Terminal: isSameCountry
          ? "N/A"
          : // : !hasDestination
            // ?
            item?.destination_terminal_handling_charges ?? 0,
        CustomsClearance: isSameCountry
          ? "N/A"
          : // : !hasDestination
            // ?
            item?.destination_customs_clearance ??
            // :
            0,
        OtherChargeValue: isSameCountry ? "N/A" : item?.other_charge_type ?? 0,
        Tariff: isSameCountry ? "N/A" : item?.tariff ?? 0,
        TariffPercentage: isSameCountry ? "N/A" : item?.tariff ?? 0,
        TariffValue:
          // from === "bookmark" && !getLatest
          //   ? // from === "bookmark"
          //     item?.tariff_updated_value
          isSameCountry ? "N/A" : tariffValue || 0,
        additionalCharges: from === "bookmark" ? item?.additional_charges : 0,
        calcOn: item?.tariff_calculate_on,
        isAdditionalCharges: false,
        isEditingCustomClearance: false,
        isEditingLocalLogistics: false,
        isEditingTariff: false,
        isEditingTerminalHandling: false,
        isEditingUnloading: false,
        otherChargesName: item?.other_charge_type,
        otherChargesValue:
          from === "bookmark"
            ? item?.other_charge_value
            : isSameCountry
            ? "N/A"
            : OtherChargesFinalValue || 0,
        otherChargeCalculatedOn: item?.other_chage_calculate_on,
        otherChargeValue: item?.other_charge_value,
      };
    });
    setData(transformedData);
  }, [destinationCountryData, countryNames, CIF, selectedHeader]);

  const handleChange = (event, index, field, country) => {
    const updatedData = [...data];
    const inputValue = event.target.value || "0";

    updatedData[index][field] = inputValue;

    const currentItem = updatedData[index];

    const valueOfSum =
      currentItem?.tariff_calculate_on === "CIF"
        ? CIF[0] && CIF[0][country?.Country]
        : country && fobData[country?.Country];

    if (field.includes("TariffValue")) {
      const x = (inputValue / (valueOfSum || 1)) * 100;
      updatedData[index][`${field}Percent`] = Number.isFinite(x)
        ? x.toFixed(2)
        : 0;
    }
    setUpdatedValue(updatedData);
  };

  // const handleSave = (key, editFlag) => {
  //   const newData = data.map((row, index) => {
  //     if (updatedValue[index] && updatedValue[index][key] !== undefined) {
  //       return {
  //         ...row,
  //         [key]: updatedValue[index][key],
  //         [editFlag]: false,
  //       };
  //     }
  //     return { ...row, [editFlag]: false };
  //   });

  //   setData(newData);
  //   updateTotals && updateTotals(newData);
  //   setUpdatedValue([]);
  // };

  const handleSave = (key, editFlag) => {
    const newData = data.map((row, index) => {
      const updatedRow = updatedValue[index];
      if (updatedRow && updatedRow[key] !== undefined) {
        let updated = { ...row, [key]: updatedRow[key] };

        const valueOfSum =
          row?.calcOn === "CIF"
            ? CIF[0] && CIF[0][row.Country]
            : row.Country && fobData[row.Country];

        if (key?.trim() === "TariffValue") {
          updated.TariffPercentage = (updatedRow[key] / valueOfSum ?? 1) * 100;
        }
        updated[editFlag] = false;

        return updated;
      }
      return { ...row, [editFlag]: false };
    });
    setData(newData);

    updateTotals && updateTotals(newData);
    setUpdatedValue([]);
  };

  React.useEffect(() => {
    updateTotals(data);
  }, [CIF, selectedOriginCity]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      updateTotals(data);
    }, 0); // or 100ms if async

    return () => clearTimeout(timeout);
  }, [data, selectedOriginCity]);

  function handleAddRow() {
    setShowRow(!showRow);
  }

  const rowConfig = [
    {
      label: "Destination Terminal Handling",
      key: "Terminal",
      editingKey: "isEditingTerminalHandling",
      isEditable: true,
    },
    {
      label: "Customs Clearance",
      key: "CustomsClearance",
      editingKey: "isEditingCustomClearance",
      isEditable: true,
    },
    {
      label: "Local Logistics",
      key: "Logistic",
      editingKey: "isEditingLocalLogistics",
      isEditable: true,
    },
    {
      label: "Tariff *",
      key: "TariffValue",
      editingKey: "isEditingTariff",
      isEditable: true,
      // suffix: "%",
      suffix: "",
    },
    {
      label: "Other Charges",
      key: "otherChargesValue",
      editingKey: "isEditingOtherCharge", // Shares toggle with tariff
      isEditable: false,
      condition: (row, selectedHeader) => row.Country !== selectedHeader,
      // displayValue: (row) => {
      //   return `${row?.otherChargesValue?.toFixed(1)} (${
      //     String(row?.otherChargesName) ? String(row?.otherChargesName) : ""
      //   })`;
      // },
      displayValue: (row) => {
        const value =
          typeof row?.otherChargesValue === "number"
            ? row.otherChargesValue.toFixed(1)
            : "";

        const name =
          row?.otherChargesName && row.otherChargesValue
            ? String(row.otherChargesName)
            : "";

        return `${value}${name ? ` (${name})` : ""}`;
      },
    },
    {
      label: "Additional Charges",
      key: "additionalCharges",
      editingKey: "isEditingAdditionalCharges",
      isEditable: true,
      suffix: "",
    },
  ];

  useEffect(() => {
    setDestinationCountryDataUpdatedData(data);
  }, [data]);

  return (
    <>
      <TableRow className="row-gap" />

      {rowConfig.map((config, rowIdx) => (
        <TableRow
          key={rowIdx}
          className={`row-height first-row ${!showRow ? "" : "fade-row"}`}
        >
          <TableCell className="row-height sticky-cell cell-height">
            <div className="align-main-cell">
              <span className="label_style">{config.label}</span>

              {config.isEditable && (
                <div
                  onClick={() => {
                    const anyEditing = data.some(
                      (row) => row[config.editingKey]
                    );
                    if (anyEditing) {
                      handleSave(config.key, config.editingKey);
                    } else {
                      // Enable editing
                      const updated = data.map((row) => ({
                        ...row,
                        [config.editingKey]: true,
                      }));
                      setData(updated);
                    }
                  }}
                  style={{ ...buttonStyle }}
                >
                  {data.some((row) => row[config.editingKey]) ? "Save" : "Edit"}
                </div>
              )}
            </div>
          </TableCell>

          {data.map((row, colIdx) => {
            const isEditing = config.editingKey && row[config.editingKey];
            const rawValue = row[config.key];
            const parsedValue = parseFloat(rawValue);
            const isVisible =
              !config.condition || config.condition(row, selectedHeader);

            return (
              <TableCell key={colIdx} align="center" sx={innerRowHeight}>
                {isEditing ? (
                  <TextField
                    value={
                      updatedValue[colIdx]?.[config.key] ?? row[config.key]
                    }
                    onChange={(e) => handleChange(e, colIdx, config.key, row)}
                    type="number"
                    sx={textFieldStyle}
                    InputProps={textFieldInput}
                  />
                ) : !isVisible ? (
                  "N/A"
                ) : !isNaN(parsedValue) ? (
                  config.displayValue ? (
                    config.displayValue(row)
                  ) : (
                    `${parsedValue.toFixed(1)}${config.suffix || ""}`
                  )
                ) : (
                  "N/A"
                )}
              </TableCell>
            );
          })}

          <TableCell className="row-height cell-height sticky-button" />
        </TableRow>
      ))}

      <TableRow sx={{ ...headerColorDDU, borderRadius: "4px" }}>
        <TableCell className="row-height main-cell sticky-cell">
          <span style={{ display: "flex", justifyContent: "space-between" }}>
            <span className="label_style">DDU</span>
            {/* <span>($/MT)</span> */}
            <span>({currency.currency_symbol}/MT)</span>
          </span>
        </TableCell>

        {totals.map((total, index) => (
          <TableCell
            key={index}
            align="center"
            className="row-height main-cell"
          >
            {total.toFixed(1)}
          </TableCell>
        ))}

        <TableCell
          className="row-height main-cell sticky-button"
          onClick={handleAddRow}
        >
          {showRow ? "+" : "-"}
        </TableCell>
      </TableRow>
    </>
  );
};

export default DestinationCountryCost;
